'use strict';

angular
    .module('app.advertiserProjectDetail')
    .factory('advertiserProjectDetailService', ['$q', '$http', '$rootScope',
        function ($q, $http, $rootScope) {
            var service = {};

            function checkResponse(data) {
              return data;
            }

            function getMessage(data) {
              if (data) {
                return data.message;
              }
              return false;
            }

            function handleRequest(url, method, params, loader) {
                var deferred = $q.defer();

                var req = {
                    url: url,
                    method: method,
                    data: JSON.stringify(params),
                    loader: loader
                } 

                $http(req)
                    .success(function (data) {
                    var dataRes = angular.fromJson(data);

                    if (checkResponse(dataRes)) {
                        deferred.resolve(dataRes);
                    } else {
                        deferred.reject(getMessage(dataRes));
                    }
                })
                    .error(function (error) {
                        deferred.reject(error);
                    });

                return deferred.promise;
            }

            function getCountryForProjectSetup(loader) {
                var url_getCountryForProjectSetup = $rootScope.apiUrl + 'admin/getCountryForProjectSetup';
                return handleRequest(url_getCountryForProjectSetup, 'GET', null, loader);
            }

            function getLanguageByCountry(params, loader) {
                var url_getLanguageByCountry = $rootScope.apiUrl + 'mention/getLanguageByCountry';
                return handleRequest(url_getLanguageByCountry, 'POST', params, loader);
            }
            
            service.getCountryForProjectSetup = getCountryForProjectSetup;
            service.getLanguageByCountry = getLanguageByCountry;

            return service;
        }
    ])

    
